import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Socket from '../../services/SocketService';
import ChatBox from './ChatBox';
import ChatBuffer from './ChatBuffer';
import ChatMembers from './ChatMembers';

class ChatRoom extends Component {
  constructor(props) {
    super(props);

    this.join = this.join.bind(this);
  }

  componentDidMount() {
    this.join();
    Socket.chat.on('connect', this.join);
  }

  componentWillUnmount() {
    Socket.chat.emit('leave', this.props.room).off('connect', this.join);
  }

  join() {
    Socket.chat.emit('join', this.props.room);
  }

  render() {
    return (
      <div className="room">
        <div className="buffer-wrap">
          <ChatBuffer room={this.props.room} />
          <ChatMembers room={this.props.room} />
        </div>
        <ChatBox room={this.props.room} />
      </div>
    );
  }
}

ChatRoom.propTypes = {
  room: PropTypes.string,
};

export default ChatRoom;
